<script setup lang="ts">
import { computed } from 'vue';
import EyeIconSvg from '@/assets/svg/conversations/eye-24.svg';
import EyeOffIconSvg from '@/assets/svg/conversations/eye-off-24.svg';
import NavbarIcon from '@/components/Shared/AppBar/DesktopDrawer/NavbarIcon.vue';
import { usePrivacyStore } from '@/core/shared/privacy/privacy.store';

const privacyStore = usePrivacyStore();

const isActive = computed(() => privacyStore.isActive);
const currentIcon = computed(() => (isActive.value ? EyeOffIconSvg : EyeIconSvg));

const tooltipText = computed(() => {
  return isActive.value ? 'Show sensitive data' : 'Hide sensitive data';
});

function togglePrivacy() {
  privacyStore.toggle();
}
</script>

<template>
  <div @click="togglePrivacy" class="cursor-pointer">
    <NavbarIcon :title="tooltipText" :src="currentIcon" :selected-src="currentIcon" />
  </div>
</template>
